import { axiosRequest } from '@/util/axios-request';
var method = 'get';
var listUrl = '/web/staff/list';
var viewUrl = '/web/staff/view';
var addUrl = '/web/staff/create';
var updateUrl = '/web/staff/edit';
var sysInfoUrl = '/web/staff/sysInfo';
var searchStaffUrl = '/web/staff/searchStaff';
var getCallTypeUrl = '/web/staff/getCallTypes';
var getSexUrl = '/web/staff/getSex';

// 员工列表
export var listUrlFn = function listUrlFn(params) {
  return axiosRequest({
    url: listUrl,
    method: method,
    params: params
  });
};

// 员工详情
export var viewUrlFn = function viewUrlFn(params) {
  return axiosRequest({
    url: viewUrl,
    method: method,
    params: params
  });
};

// 新增
export var addFn = function addFn(data) {
  return axiosRequest({
    url: addUrl,
    data: data
  });
};

// 更新
export var updateFn = function updateFn(data) {
  return axiosRequest({
    url: updateUrl,
    data: data
  });
};

// 员工基础信息
export var sysInfoFn = function sysInfoFn() {
  return axiosRequest({
    url: sysInfoUrl,
    method: method
  });
};

// 员工搜索（姓名和手机号）
export var searchStaffFn = function searchStaffFn(params) {
  return axiosRequest({
    url: searchStaffUrl,
    method: method,
    params: params
  });
};

// 获取称谓
export var getCallTypeUrlMethod = function getCallTypeUrlMethod(params) {
  return axiosRequest({
    url: getCallTypeUrl,
    method: method,
    params: params
  });
};

// 获取性别
export var getSexUrlMethod = function getSexUrlMethod(params) {
  return axiosRequest({
    url: getSexUrl,
    method: method,
    params: params
  });
};

// 需要导出的字段
export var getExportColumns = function getExportColumns(params) {
  return axiosRequest({
    url: '/web/staff/getExportColumns',
    method: method,
    params: params
  });
};

// 导出
export var exportData = function exportData(params) {
  return axiosRequest({
    url: '/web/staff/export',
    method: method,
    params: params
  });
};

// 转正管理列表
export var getRegularLists = function getRegularLists(params) {
  return axiosRequest({
    url: '/web/staff_regular/lists',
    method: method,
    params: params
  });
};

// 试用期管理枚举项
export var getRegularInfo = function getRegularInfo(params) {
  return axiosRequest({
    url: '/web/staff_regular/init',
    method: method,
    params: params
  });
};

// 转正管理列表导出
export var regularExport = function regularExport(params) {
  return axiosRequest({
    url: '/web/staff_regular/export',
    method: method,
    params: params
  });
};

// 办理转正
export var addStaffRegular = function addStaffRegular(params) {
  return axiosRequest({
    url: '/web/staff_regular/addStaffRegular',
    method: method,
    params: params
  });
};

// 编辑转正信息
export var editStaffRegular = function editStaffRegular(params) {
  return axiosRequest({
    url: '/web/staff_regular/editStaffRegular',
    method: method,
    params: params
  });
};

// 编辑转正信息
export var cancelStaffRegular = function cancelStaffRegular(params) {
  return axiosRequest({
    url: '/web/staff_regular/cancelStaffRegular',
    method: method,
    params: params
  });
};

// 获取国家
export var getCountries = function getCountries(params) {
  return axiosRequest({
    url: '/web/address/countries',
    method: method,
    params: params
  });
};